export default __webpack_public_path__ + "static/media/voucher.a3ebb176.jpg";